const ModalDialog = videojs.getComponent('ModalDialog');

const DEFAULTS = {
  label: 'Уведомление',
  pauseOnOpen: false,
  temporary: false,
  uncloseable: false,
  liveTime: 10
};

class NotificationModal extends ModalDialog {
  constructor(player, options) {
    super(player, Object.assign({}, DEFAULTS, options));
    this.addClass('vjs-notification');
  }

  showMessage(message) {
    this.content(message);
    this.open();
  }

  open() {
    super.open();
    this.player().controls(true);
  }
}

videojs.registerComponent('NotificationModal', NotificationModal);
export default NotificationModal;
